import React from "react"
import arrowsOld from "../assets/two-arrows.png"
import arrowsNew from "../assets/two-arrows-black.png"

function Header({ merchant, client }) {
  const arrows = merchant?.category ? arrowsNew : arrowsOld

  return (
    <div className="header">
      <div>
        <img src={client.iconUrl} alt={client.name} className="client-logo" />
      </div>
      <div>
        <img src={arrows} alt="Arrows" />
      </div>
      <div title="Merchant Details">
        <img
          src={merchant.iconUrl}
          alt={merchant.name}
          className="merchant-logo"
        />
      </div>
    </div>
  )
}

export default Header
